import React from 'react'
import BannerImage from '@/assets/image/banner.png';
import Image from 'next/image';

const Banner = ({title}) => {
  return (
    <div className="relative w-full h-64 md:h-80 lg:h-100 ">
      <Image
        src={BannerImage}
        alt="Our Stories Banner"
        fill
        className="object-cover"
        priority
        loading='eager'
      />
      <div className="absolute inset-0 bg-black/50" />
      <div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center text-white">
        <h1 className="text-[25px] md:text-[35px] font-bold mb-2 md:max-w-[90%] lg:max-w-[90%]"  style={{ fontFamily: "GD Boing" }}>{title}</h1>
        {/* <p className="text-[18px] md:text-[22px]" >Home / Blog</p> */}
      </div>
    </div>
  );
};

export default Banner;
